import {Component} from '@angular/core'
import {ListComponent} from 'src/app/shared/ui/list/list.component'
import {FiltersComponent} from 'src/app/shared/ui/filters/filters.component'

@Component({
    selector: 'app-manager',
    templateUrl: './manager.component.html',
    styleUrls: ['./manager.component.scss'],
    imports: [
        FiltersComponent,
        ListComponent,
    ]
})
export class ManagerComponent {
    constructor() {}

}
